import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import DownloadService from '@/utils/download'
import downloadUtil from '@/utils/downloadUtil'

const state = {
  message: {
    content: '',
    type: ''
  },
  manualList: []
}

const actions = {

  async getInitData ({ dispatch, state, commit }) {
    this.dispatch('loading/loadingPagePlus')
    commit('init')
    let type = 'success'
    const response = await ApiManager.request('Manual').manualList()
    // const response = await ApiManager.requestMock('manualList')
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setManualList', response.data.data)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
    return response.data.data
  },
  /**
   * ダウンロードを実行する
   */
  async download ({ state, commit }, slug) {
    this.dispatch('loading/loadingPagePlus')
    commit('init')
    const response = await DownloadService.downloadManual(slug)
    commit('setManualFile', { data: response, name: slug })
  }
}

const mutations = {
  init (state, data) {
    state.message = {
      content: '',
      type: ''
    }
  },
  setMessage (state, data) {
    state.message = data
  },
  setManualList (state, data) {
    state.manualList = data
  },
  setManualFile (state, data) {
    downloadUtil(data.data, data.name)
    this.dispatch('loading/loadingPageMinus')
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
